module.exports = __webpack_public_path__ + "img/img_23.7d6f859e.jpg";